class RegimenCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.track = this.querySelector('[data-regimen-track]');
    this.dots = [...this.querySelectorAll('[data-regimen-dot]')];
    if (!this.track || this.dots.length < 2) return;

    this.initialized = true;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.ticking = false;

    this.track.addEventListener('scroll', () => this.requestUpdate(), { signal, passive: true });

    for (const [index, dot] of this.dots.entries()) {
      dot.addEventListener('click', () => this.scrollToDot(index), { signal });
    }

    this.updateActiveDot();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.initialized = false;
  }

  requestUpdate() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.updateActiveDot();
      this.ticking = false;
    });
  }

  updateActiveDot() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const ratio = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
    const activeIndex = Math.round(ratio * (this.dots.length - 1));

    for (const [index, dot] of this.dots.entries()) {
      if (index === activeIndex) {
        dot.setAttribute('data-active', '');
      } else {
        dot.removeAttribute('data-active');
      }
    }
  }

  scrollToDot(index) {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const left = maxScroll * (index / (this.dots.length - 1));
    this.track.scrollTo({ left, behavior: 'smooth' });
  }
}

if (!customElements.get('regimen-carousel')) {
  customElements.define('regimen-carousel', RegimenCarousel);
}
